import React, { createContext, useContext, useMemo, useState } from 'react';

const SiteBackgroundContext = createContext({
  aboutProgress: 0,
  setAboutProgress: () => {},
  isSiteReady: false,
  setIsSiteReady: () => {},
});

export function SiteBackgroundProvider({ children }) {
  const [aboutProgress, setAboutProgress] = useState(0);
  const [isSiteReady, setIsSiteReady] = useState(false);
  const value = useMemo(
    () => ({ aboutProgress, setAboutProgress, isSiteReady, setIsSiteReady }),
    [aboutProgress, isSiteReady]
  );
  return <SiteBackgroundContext.Provider value={value}>{children}</SiteBackgroundContext.Provider>;
}

export function useSiteBackground() {
  return useContext(SiteBackgroundContext);
}

export default SiteBackgroundContext;
